﻿export class AppConfig {
   public readonly iocurl: string = '';
   public readonly apiUrl: string = '';
   public readonly campusUrl: string = '';
   public readonly baseUrl: string = '';
   public readonly sessionapi = '/ioc/lib/serveiweb/sec_checksession.php';
   public readonly wsapi = '/sec/data/getdata.php';
   public readonly uploadRoute = '/sec/data/uploadfile.php';
   public readonly uploadCsvRoute = '/sec/data/uploadcsvfile.php';
   public readonly downloadRoute = '/sec/data/downloadfile.php';

   constructor() {
        const url = document.location.pathname.substring(0, document.location.pathname.lastIndexOf('/sec/'));
        this.apiUrl = document.location.protocol + '//' + document.location.host + url;
        this.campusUrl = document.location.protocol + '//' + document.location.host + '/campus';
        this.baseUrl = url + '/sec/';
        this.iocurl = 'https://' + document.location.host + '/ioc/';
   }
}

export function getBaseLocation() {
    const url = document.location.pathname.substring(0, document.location.pathname.lastIndexOf('/sec/'));
    return url + '/sec/';
}
